export default __webpack_public_path__ + "static/media/hami_video_05.3e0c42ed.jpg";